import React from 'react';
import { InputNumber, Form } from 'antd';
import PropTypes from 'prop-types';
import './PrntCalcario.scss';
import '../fieldsStyle.scss';

const PrnCalcarioField = (props) => {
  const {
    rules,
    min,
    max,
    name,
    value,
    edit,
  } = props;

  return (
    <Form.Item
      label={<span className="field-title-text">PRNT do Calcário</span>}
      name={name}
      rules={rules}
      initialValue={value || undefined}
    >
      <InputNumber
        style={{ width: '100%' }}
        disabled={edit}
        {...(min !== null && max !== null ? { min, max } : {})}
      />
    </Form.Item>
  );
};

PrnCalcarioField.defaultProps = {};
PrnCalcarioField.propTypes = {
  rules: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  name: PropTypes.string.isRequired,
  value: PropTypes.number,
  edit: PropTypes.bool,
};

export default PrnCalcarioField;
